import styled from 'styled-components';

import { ButtonRoundedSmall, Input } from '@comeon/ui';

export const PaymentButtonSecondary = styled(ButtonRoundedSmall)`
	align-items: center;
	display: flex;
	font: var(--h3);
	justify-content: center;
	margin: 0;
	min-height: 52px;
	width: 100%;
	border-radius: var(--new-qd--modal-button-rounding, 26px);

	span {
		margin: auto 6px;
	}

	svg,
	svg * {
		fill: ${({ disabled }) =>
			disabled ? `var(--button-disabled-text)` : 'var(--button-primary-text,rgba(var(--base-02),1))'};
	}
`;

export const StyledCVVInput = styled(Input)`
	font: var(--h1);
	background-color: var(--new-qd--amount-input-bg);
	color: var(--new-qd--amount-input-text-color);
	height: 56px;
	text-align: center;
	margin: 0;
	padding: 0;
	vertical-align: middle;

	// to increase specificity
	&& {
		border-bottom-color: rgba(var(--new-qd--amount-input-border-color), 1);
		border-bottom-width: 1px;
	}

	&:focus {
		border-bottom-color: var(--new-qd--amount-input-focus-border-color);
		color: var(--new-qd--amount-input-focus-text-color);
	}
`;
